import React from 'react'
import useStyles from './styles'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'

interface Props {
  iconUrl: string
  titleKey: string
  badge?: string | null
  addDisclaimer?: boolean
  removeFilter?: boolean
}

export const TreatmentTile = ({ addDisclaimer = false, iconUrl, titleKey, badge, removeFilter }: Props) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const classes = useStyles()

  const imageColor = theme.palette.primary[800]

  return (
    <div className={classes.tile}>
      <div
        className={classes.tileIcon}
        style={{
          backgroundColor: imageColor,
          WebkitMaskImage: `url(${iconUrl})`,
          maskImage: `url(${iconUrl})`,
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
        }}
      ></div>

      <div className={classes.treatmentName}>
        {t(titleKey)}
        {addDisclaimer && '*'}
      </div>
      {badge && <div className={classes.badge}>{badge}</div>}
    </div>
  )
}
